
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./GestionCamiones.css";
import API from "../api";

function GestionCamiones() {
  const navigate = useNavigate();
  const [camiones, setCamiones] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [camionEditando, setCamionEditando] = useState(null);


  const [form, setForm] = useState({
    placa: "",
    marca: "",
    anio: "",
    tipo: "Camión",
    rendimiento_km_galon: ""
  });

  const cargarCamiones = async () => {
    try {
      setError("");

      const token = sessionStorage.getItem("token");

      if (!token) {
        throw new Error(
          "No se encontró una sesión. Inicia sesión nuevamente."
        );
      }

      const respuesta = await fetch(
  `${API}/gestion-vehiculos`,
  {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const datos = await respuesta.json();

      if (!respuesta.ok) {
        throw new Error(
          datos.error || "No se pudieron cargar los camiones"
        );
      }

      setCamiones(datos);
    } catch (err) {
      setError(err.message);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargarCamiones();
  }, []);

  
const reactivarCamion = async (camion) => {
  if (camion.estado !== "Inactivo") {
    setError("Solo puedes reactivar camiones inactivos.");
    return;
  }

  const confirmar = window.confirm(
    `¿Deseas reactivar el camión con placa ${camion.placa}?`
  );

  if (!confirmar) return;

  setError("");
  setMensaje("");

  try {
    const token = sessionStorage.getItem("token");

    if (!token) {
      throw new Error("Debes iniciar sesión nuevamente.");
    }

    const respuesta = await fetch(
  `${API}/gestion-vehiculos/${camion.id_vehiculo}/reactivar`,
      {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    const datos = await respuesta.json();

    if (!respuesta.ok) {
      throw new Error(
        datos.error || "No se pudo reactivar el camión."
      );
    }

    await cargarCamiones();
    setMensaje("Camión reactivado correctamente.");
  } catch (err) {
    setError(err.message);
  }
};

  
const desactivarCamion = async (camion) => {
  if (camion.estado === "Inactivo") {
    setError("Este camión ya se encuentra inactivo.");
    return;
  }

  const confirmar = window.confirm(
    `¿Estás seguro de desactivar el camión con placa ${camion.placa}?`
  );

  if (!confirmar) return;

  setError("");
  setMensaje("");

  try {
    const token = sessionStorage.getItem("token");

    if (!token) {
      throw new Error("Debes iniciar sesión nuevamente.");
    }

    const respuesta = await fetch(
  `${API}/gestion-vehiculos/${camion.id_vehiculo}/desactivar`,
  {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    const datos = await respuesta.json();

    if (!respuesta.ok) {
      throw new Error(
        datos.error || "No se pudo desactivar el camión."
      );
    }

    setMensaje("Camión desactivado correctamente.");
    await cargarCamiones();

  } catch (err) {
    setError(err.message);
  }
};


  const iniciarEdicion = (camion) => {
  setCamionEditando(camion.id_vehiculo);

  setForm({
    placa: camion.placa || "",
    marca: camion.marca || "",
    anio: camion.anio ?? "",
    tipo: camion.tipo || "Camión",
    rendimiento_km_galon:
      camion.rendimiento_km_galon ?? ""
  });

  setMostrarFormulario(true);
  setError("");
  setMensaje("");

  window.scrollTo({ top: 0, behavior: "smooth" });
};

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const registrarCamion = async (e) => {
    e.preventDefault();

    if (guardando) return;

    setGuardando(true);
    setError("");
    setMensaje("");

    try {
      const token = sessionStorage.getItem("token");

      if (!token) {
        throw new Error("Debes iniciar sesión nuevamente.");
      }

const respuesta = await fetch(
  camionEditando
    ? `${API}/gestion-vehiculos/${camionEditando}`
    : `${API}/gestion-vehiculos`,
  {
    method: camionEditando ? "PATCH" : "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify(form)
        }
      );

      const datos = await respuesta.json();

      if (!respuesta.ok) {
        throw new Error(
          datos.error || "No se pudo registrar el camión"
        );
      }

      setMensaje(
  camionEditando
    ? "Camión actualizado correctamente."
    : "Camión registrado correctamente."
);

      setForm({
        placa: "",
        marca: "",
        anio: "",
        tipo: "Camión",
        rendimiento_km_galon: ""
      });

      setCamionEditando(null);
      setMostrarFormulario(false);
      await cargarCamiones();

    } catch (err) {
      setError(err.message);
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div className="gestion-camiones">
      <header className="camiones-header">
        <span className="camiones-marca">Transportes Figueroa</span>
        <button type="button" onClick={() => navigate("/dashboard")} className="camiones-btn camiones-btn-volver">
          ← Volver al Dashboard
        </button>
      </header>
      <div className="camiones-contenido">

      <h1 className="camiones-titulo">
  Gestión de Camiones
</h1>

<p className="camiones-subtitulo">
  Administración de camiones de Transportes Figueroa.
</p>

      <button
        type="button"

onClick={() => {
  setMostrarFormulario(!mostrarFormulario);
  setCamionEditando(null);

  setForm({
    placa: "",
    marca: "",
    anio: "",
    tipo: "Camión",
    rendimiento_km_galon: ""
  });

  setError("");
  setMensaje("");
}}
        className="camiones-btn camiones-btn-registrar"
      >
        {mostrarFormulario
          ? "Cancelar"
          : "+ Registrar camión"}
      </button>

{mostrarFormulario && (
  <form
    onSubmit={registrarCamion}
    className="camiones-formulario"
  >
    <h2>
      {camionEditando
        ? "Editar información del camión"
        : "Registrar nuevo camión"}
    </h2>

          {[
            { nombre: "placa", etiqueta: "Placa", tipo: "text" },
            { nombre: "marca", etiqueta: "Marca", tipo: "text" },
            { nombre: "anio", etiqueta: "Año", tipo: "number" },
            {
              nombre: "rendimiento_km_galon",
              etiqueta: "Rendimiento (km/galón)",
              tipo: "number"
            }
          ].map((campo) => (
            <div
              key={campo.nombre}
              className="camiones-campo"
            >
              <label
                htmlFor={campo.nombre}
                
              >
                {campo.etiqueta}
              </label>

              <input
                id={campo.nombre}
                type={campo.tipo}
                name={campo.nombre}
                value={form[campo.nombre]}
                onChange={handleChange}
                required={
                  campo.nombre !== "anio"
                }
                min={
                  campo.nombre === "anio"
                    ? 1900
                    : campo.nombre === "rendimiento_km_galon"
                    ? 0.01
                    : undefined
                }
                max={
                  campo.nombre === "anio"
                    ? new Date().getFullYear() + 1
                    : campo.nombre === "rendimiento_km_galon"
                    ? 9999.99
                    : undefined
                }
                step={
                  campo.nombre === "rendimiento_km_galon"
                    ? "0.01"
                    : undefined
                }
                maxLength={
                  campo.nombre === "placa"
                    ? 20
                    : campo.nombre === "marca"
                    ? 50
                    : undefined
                }
              />
            </div>
          ))}

          <div className="camiones-campo">
            <label htmlFor="tipo">Tipo de vehículo</label>

            <input
              id="tipo"
              type="text"
              name="tipo"
              value={form.tipo}
              onChange={handleChange}
              required
              maxLength={50}
            />
          </div>

          <button
            type="submit"
            disabled={guardando}
            className="camiones-btn camiones-btn-guardar"
          >
            {guardando
  ? "Guardando..."
  : camionEditando
  ? "Guardar cambios"
  : "Guardar camión"}
          </button>
        </form>
      )}

      {mensaje && (
        <p className="camiones-mensaje">{mensaje}</p>
      )}

      {error && (
        <p className="camiones-error">{error}</p>
      )}

      <h2>Camiones registrados</h2>

      {cargando ? (
        <p>Cargando camiones...</p>
      ) : (
       <div className="camiones-tabla-contenedor">

<table className="camiones-tabla">
            <thead>
              <tr>
                <th>Placa</th>
                <th>Marca</th>
                <th>Año</th>
                <th>Tipo</th>
                <th>Rendimiento</th>
                <th>Estado</th>
                <th>Conductor asignado</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {camiones.length === 0 ? (
                <tr>
                  <td colSpan="8">
                    No hay camiones registrados.
                  </td>
                </tr>
              ) : (
                camiones.map((camion) => (
                  <tr key={camion.id_vehiculo}>
                    <td>{camion.placa}</td>
                    <td>{camion.marca}</td>
                    <td>{camion.anio ?? "—"}</td>
                    <td>{camion.tipo}</td>
                    <td>
                      {camion.rendimiento_km_galon ?? "—"} km/gal
                    </td>
                    <td>{camion.estado}</td>
                    <td>
                      {camion.conductor_asignado || "Sin asignar"}
                    </td>
                    <td>
  <div className="camiones-acciones">
  <button
    type="button"
onClick={() => iniciarEdicion(camion)}
    className="camiones-btn camiones-btn-editar"
  >
    Editar
  </button>

  

{camion.estado === "Inactivo" ? (
  <button
    type="button"
    onClick={() => reactivarCamion(camion)}
    className="camiones-btn camiones-btn-reactivar"
  >
    Reactivar
  </button>
) : (
  <button
    type="button"
    onClick={() => desactivarCamion(camion)}
    className="camiones-btn camiones-btn-desactivar"
  >
    Desactivar
  </button>
)}

  </div>
</td>

                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
      </div>
    </div>
  );
}

export default GestionCamiones;
